export default __webpack_public_path__ + "static/Montserrat-Regular-518803d3e08549d2d704d9a6643a3887.woff2";